/**
 * Session-orchestration constants. Tunable in one place after observing real
 * use; design decision 10 (5-trial sessions) and 6 (streak threshold) reside
 * here so they can be bumped without grepping the codebase.
 */
export const TRIALS_PER_SESSION = 5;
export const STREAK_THRESHOLD = 3;
